export default {
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '',
          title: '',
          data: {}
        };
      }
    }
  },
  data() {
    return {
      visible: true,
    };
  },
};
